/**
 * DevExtreme (esm/ui/overlay/ui.overlay.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Overlay from "../../__internal/ui/overlay/m_overlay";
export default Overlay;
